import { RootState } from '../store';

export const selectFamilyResponsabilities = (state: RootState) =>
  state.familyResponsabilities?.data;
